var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShanchuXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 5.7l4.6 4.6m0-4.6l-4.6 4.6",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTQuNUMxMS41ODk5IDE0LjUgMTQuNSAxMS41ODk5IDE0LjUgOEMxNC41IDQuNDEwMTUgMTEuNTg5OSAxLjUgOCAxLjVDNC40MTAxNSAxLjUgMS41IDQuNDEwMTUgMS41IDhDMS41IDExLjU4OTkgNC40MTAxNSAxNC41IDggMTQuNVoiIHN0cm9rZT0iIzNGNDY1QyIvPgo8cGF0aCBkPSJNNS43MDA1IDUuNjk5OTVMMTAuMyAxMC4yOTk1TTEwLjI5OTUgNS42OTk5NUw1LjcwMDAxIDEwLjI5OTUiIHN0cm9rZT0iIzNGNDY1QyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgTongyongShanchuXian as ReactComponent };